/* eslint-disable no-console */
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { track } from '../../external_dependencies/analytic/index';
import { InstallmentsStyles } from './InstallmentsWithoutInterest.style';

const InstallmentsWithoutInterest = ({ product, userSegments, isUserLoggedIn }) => {
  const { installmentsWithoutInterest = [] } = product;
  const segments = userSegments || [];

  useEffect(() => {
    if (typeof window !== 'undefined' && window && window.digitalData) {
      const userSegmentNames = segments?.map((segmentItem) => segmentItem?.name)?.join('|');
      window.digitalData.usersegment = userSegmentNames || null;
    }
  }, [userSegments]);

  if (!installmentsWithoutInterest.length) {
    return null;
  }

  let maxInstallments = 0;

  if (isUserLoggedIn) {
    const userSegmentNames = segments?.map((segmentItem) => segmentItem.name);
    const filteredInstallmentsWithoutInterest = installmentsWithoutInterest.filter((itemWithoutInterest) => {
      if (!itemWithoutInterest?.userSegment?.length) {
        return itemWithoutInterest;
      }
      const isInstallmentsWithoutInterestInUserSegment = itemWithoutInterest.userSegment.some((itemUserSegment) =>
        userSegmentNames.includes(itemUserSegment)
      );
      return isInstallmentsWithoutInterestInUserSegment && itemWithoutInterest;
    });
    const uniqueInstallments = [
      ...new Set(filteredInstallmentsWithoutInterest.map((item) => Number(item.installments))),
    ];

    maxInstallments = uniqueInstallments.length > 0 ? Math.max(...uniqueInstallments) : 0;
  } else {
    const itemWithHighestinstallment = installmentsWithoutInterest?.reduce((max, current) =>
      current.installments > max.installments ? current : max
    );

    if (itemWithHighestinstallment && !itemWithHighestinstallment?.userSegment?.length) {
      maxInstallments = itemWithHighestinstallment.installments;
    } else {
      return null;
    }
  }

  // eslint-disable-next-line no-underscore-dangle
  if (maxInstallments > 0 && typeof window !== 'undefined' && window && window._satellite) {
    track('segmentedcsi');
  }

  return maxInstallments > 0 ? (
    <>
      <div className="installments-text">
        <span className="cmr-icon" />
        <span>{maxInstallments} cuotas sin interés</span>
      </div>
      <style jsx>{InstallmentsStyles}</style>
    </>
  ) : null;
};

InstallmentsWithoutInterest.defaultProps = {
  product: {},
  userSegments: [],
  isUserLoggedIn: false,
};

InstallmentsWithoutInterest.propTypes = {
  product: PropTypes.object,
  userSegments: PropTypes.array,
  isUserLoggedIn: PropTypes.bool,
};

export default InstallmentsWithoutInterest;
